<template>
    <div class="playpage-wrapper">
        <div class="play-page">
            <div class="play-page__left-image">
                <ImageOptimized
                    :file-name="'/home/play/messageboard-third-section'"
                    :alt="'Play'"
                    :sizes="['600', '1000', '1920']"
                    :load="'lazy'"
                />
            </div>
            <div class="play-page__content">
                <div class="play-page__content-header">
                    <PlayPageLogo
                        class="play-page__content-header--logo"
                    ></PlayPageLogo>
                    <div class="play-page__content-header--title">
                        Play
                    </div>
                </div>

                <div class="play-page__content-description">
                    <p>
                        Enjoy
                        <strong>hundreds of different games</strong> across
                        every genre imaginable, the entire creative output of a
                        welcoming community, bustling with creativity - at your
                        fingertips.
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import PlayPageLogo from '../../../assets/svg/play-page-logo.svg?inline';
import ImageOptimized from '@/components/common/ImageScaler';

export default {
    name: 'YlandsCreatorsClub',
    components: {
        PlayPageLogo,
        ImageOptimized,
    },
};
</script>

<style scoped lang="scss">
.playpage-wrapper {
    position: relative;
    overflow: hidden;
    background: url('~Images/home/backgr-home-third-section.png') no-repeat
        center center;
    background-size: cover;
    @media (max-width: $xm-up) {
        background: url('~Images/home/backgr-home-third-section_1024.png')
            no-repeat center center;
        background-size: cover;
    }
    @media (max-width: $xs-up) {
        background: url('~Images/home/backgr-home-third-section_500.png')
            no-repeat center center;
        background-size: cover;
    }
    display: flex;
    justify-content: center;
}
.play-page {
    display: flex;
    max-width: 1280px;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    margin: 0 25px;
    padding: 120px 0;

    @media (max-width: $sm-up) {
        flex-direction: column-reverse;
        padding: 45px 0;
    }

    .play-page__content {
        flex: 1 3 auto;

        @media (max-width: $sm-up) {
            margin-bottom: 30px;
        }
        .play-page__content-header {
            display: flex;
            align-items: center;

            @media (max-width: $sm-up) {
                justify-content: center;
            }

            @media (max-width: $xs-up) {
                flex-direction: column;
            }
            &--logo {
                margin-right: 14px;
                @media (max-width: $xs-up) {
                    margin-right: 0;
                    margin-bottom: 30px;
                }
            }
            &--title {
                text-align: left;
                color: $blue-main;
                font-family: $politica-font;
                font-size: 55px;
                font-weight: 700;
                letter-spacing: 2.5px;
                line-height: 60px;

                @media (max-width: $xs-up) {
                    font-size: 35px;
                    letter-spacing: 0.7px;
                    line-height: 40px;
                    text-align: center;
                }
            }
        }
        .play-page__content-description {
            font-family: $palanquin-font;
            font-size: 18px;
            font-weight: 400;
            letter-spacing: 0.56px;
            line-height: 30px;
            color: $blue-main;

            @media (max-width: $sm-up) {
                text-align: center;
            }
        }
    }
}
</style>
